export const handleFormatDateIfIsNull = (value: string) => {
  const resultDate = value ? value.split("T")[0] : "";

  return resultDate;
};
